import AuditLogsTable from './Table';

export default AuditLogsTable;
